import Vue from 'vue';
import VueRouter from 'vue-router';
import base from './base';


const OriginalPush = VueRouter.prototype.push,
    createRouter = () =>
        new VueRouter({
            mode: 'history',
            routes: [...base]
        }),
    Router = createRouter(),
    resetRouter = () => {
        const newRouter = createRouter();

        Router.matcher = newRouter.matcher;
    };

VueRouter.prototype.push = function push(location) {
    return OriginalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);
const editType = {
    edit: '编辑',
    review: '查看',
    add: '新增'
};
Router.afterEach((to, from) => {
    document.title = '三峰E路行-' + (editType[to.query.editType] || '') + to.meta.title;
});
export { resetRouter };
export default Router;
